import { Injectable }     from '@angular/core';
import { CanActivate }    from '@angular/router';

import { Router,
         NavigationExtras,
         ActivatedRouteSnapshot,
         RouterStateSnapshot} from '@angular/router';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';

import { AngularFireAuth } from 'angularfire2/auth';

import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

// Service that stores the next URL where the user should go after login.
@Injectable()
export class AuthService {
    nextUrl : string = "/"

    user : Observable<firebase.User>

    constructor(public afAuth : AngularFireAuth, public router : Router) {
        this.user = this.afAuth.authState;
    }

    private login(provider : firebase.auth.AuthProvider, redirect = true) {

        return this.afAuth.auth.signInWithPopup(provider).then((result : firebase.auth.UserCredential) => {
            if (!result) {
                return Promise.reject({
                    code: "internal_empty_response",
                    message: "Login failed for an unexpected reason :(. Please try again."
                });
            }
            if (redirect) {
                this.router.navigate([this.nextUrl]);
            }
            return Promise.resolve(result);
        }).catch((err : firebase.FirebaseError) => {

            console.log("Login error", err);

            // fetching available providers to make things easier in UI code
            if (err.code == "auth/account-exists-with-different-credential") {
                return this.afAuth.auth.fetchProvidersForEmail((err as any).email).catch(err2 => {
                    err["available_providers"] = [];
                    return Promise.reject(err);
                }).then(data => {
                    err["available_providers"] = data;
                    return Promise.reject(err);
                });
            }

            return Promise.reject(err);
        });
    }

    loginFacebook(redirect = true) {
        return this.login(new firebase.auth.FacebookAuthProvider(), redirect);
    }

    loginGoogle(redirect = true) {
        return this.login(new firebase.auth.GoogleAuthProvider(), redirect);
    }

    logout() {
        return this.afAuth.auth.signOut().then((a) => {
            // successful logout, redirect user back to login.
            console.log("logged out!", a, this.afAuth.auth);
            this.router.navigate(["/login"]);
            return a;
        });
    }

    linkWithCredential(credential : firebase.auth.AuthCredential) {
        return this.afAuth.auth.currentUser.linkAndRetrieveDataWithCredential(credential).then(ok => {
            console.log("LINK SUCCESS", ok);
            return ok;
        }).catch(err => {console.log("link err", err); return Promise.reject(err); });
    }

}

@Injectable()
export class UsersOnly implements CanActivate {

    constructor(
        public auth : AuthService,
        public router : Router) {}

    canActivate(route : ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.auth.user.map(auth => auth ? true : false).do(result => {
            if (result == true){ return; }

            console.log("UsersOnly canActivate result", result, "this", this);

            // if rejected, set nextUrl and redirect to login
            this.auth.nextUrl = state.url

            // Redirect the user
            this.router.navigate(["/login"]);
        });
    }
}

@Injectable()
export class GuestsOnly implements CanActivate {

    constructor(public auth : AuthService, public router : Router) {}

    canActivate() {
        return this.auth.user.map(auth => {
            var result = auth ? false : true;
            return result;
        }).do(result => {
            if (result == true) { return; }
            console.log("GuestsOnly guard result", result, "this:", this);

            // Redirect the logged in user to home page
            this.router.navigate(["/"]);
        });
    }
}



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/auth/guard.service.ts